/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const getMyPreferredDentistsAction = createAction('REFORAL_GET_MY_PREFERRED_DENTISTS');
export const getReferralsCountAction = createAction('REFORAL_GET_REFERRALS_COUNT');
export const getMessageListAction = createAction('REFORAL_GET_MESSAGE_LIST');
export const getClinicMessageListAction = createAction('REFORAL_GET_CLINIC_MESSAGE_LIST');
export const getLabOrderMessageListAction = createAction('REFORAL_GET_LAB_ORDER_MESSAGE_LIST');
export const getMyPreferredCustomersAction = createAction('REFORAL_GET_MY_PREFERRED_CUSTOMERS');
export const getLabOrdersCountAction = createAction('REFORAL_GET_LAB_ORDERS_COUNT');

export const setHasRedirectToPackagesAction = createAction('REFORAL_SET_HAS_REDIRECT_TO_PACKAGES');
export const setDashboardFilterAction = createAction('REFORAL_SET_DASHBOARD_FILTER');
